/** @module csi/toolbar/SortImages */
define([
	"dojo/_base/declare",
	"dojo/when",
	"dijit/_Container",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"csi/state/rootStore",
	"dojo/text!./SortImages.html",
	"csi/widget/ComboBox"
], function(declare, when, _Container, _TemplatedMixin, _WidgetBase, _WidgetsInTemplateMixin, {localStore}, template) {

	return declare([_WidgetBase, _Container, _TemplatedMixin, _WidgetsInTemplateMixin], {
		templateString: template,

		/** @property {string} defaultValue - default selection value for the dropdown */
		defaultValue: "",

		/**
		 * Event Handler - sets sort options on options change
		 * @param {String} newValue
		 */
		_onChangeSortImages: function(newValue) {
			var selectedObj = this.store.query({name: newValue})[0];
			localStore.imageSort = selectedObj.key;
			var sortObj = [{
				attribute: selectedObj.attribute,
				descending: selectedObj.descending
			}];
			this.onChange(sortObj);
		},

		/**
		 * Set store for this widget, and store for combo
		 * @param {Store} store
		 */
		_setStoreAttr: function(store) {
			this._set("store", store);
			this._updateSort(this.defaultValue);
		},

		/**
		 * Sets the sort options for initial selection while switching views
		 */
		setOption: function(option) {
			var self = this;
			if (option && option.attribute) {
				when(this.store.query(option), function(res) {
					if (res.length) {
						self._updateSort(res[0].name, true);
					}
				});
			}
		},

		/**
		 * set sort store and value
		 * @param {String} value
		 * @param {Boolean} ignoreStore - prevents setting of store
		 */
		_updateSort: function(value, ignoreStore) {
			var store = this.store;
			this._comboNode._onChangeActive = false;
			if (!ignoreStore) {
				this._comboNode.set("store", store);
			}
			this._comboNode.set("value", value);
			this._comboNode._onChangeActive = true;
		}
	})
});